import { positionsInTheCompanyEnum } from "@dune/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { DefaultValues, useForm } from "react-hook-form";
import { z } from "zod";

const mobilePhoneRegex = /^(\+33|0)(6|7)(\d{2}){4}$/;

const landlinePhoneRegex = /^(\+33|0)(1|2|3|4|5|9)(\d{2}){4}$/;

const registerMainDetailsFormSchema = z.object({
	lastname: z.string().min(1, "Le nom est requis"),
	firstname: z.string().min(1, "Le prénom est requis"),
	email: z.email("Email invalide").min(1, "L'email est requis"),
	function: z.enum(positionsInTheCompanyEnum, {
		error: "La fonction est requise",
	}),
	phone: z
		.string()
		.regex(mobilePhoneRegex, { message: "Numéro mobile invalide" })
		.min(1, "Le mobile est requis"),
	landlinePhone: z
		.string()
		.regex(landlinePhoneRegex, { message: "Numéro fixe invalide" })
		.optional()
		.or(z.literal("")),
	oriasNumber: z.string().optional(),
	siren: z.string().optional(),
	denomination: z.string().optional(),
	headquartersAddress: z.string().optional(),
});

export type RegisterMainDetailsFormData = z.infer<
	typeof registerMainDetailsFormSchema
>;

export function useRegisterMainDetailsForm(
	defaultValues: DefaultValues<RegisterMainDetailsFormData>,
) {
	const {
		control,
		handleSubmit,
		getValues,
		formState: { errors },
	} = useForm<RegisterMainDetailsFormData>({
		defaultValues,
		resolver: zodResolver(registerMainDetailsFormSchema),
	});

	return {
		control,
		handleSubmit,
		getValues,
		errors,
	};
}
